import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import MinorStrataService from "@services/MinorStrataService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import SubStrataSelect from "@components/SubStrata/partials/SubStrataSelect";

const CreateMinorStrata = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [subStratumId, setSubStratumId] = useState();

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setSubStratumId();
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    MinorStrataService.create(name, englishName, subStratumId, description)
      .then(() => {
        showSuccess(t("minorStrataCreatedSuccessfully"));
        onAdded();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"create_minor_stratum"}>
      <AddButton
        label={t("addMinorStratum")}
        onClick={() => setShowModal(true)}
      />
      <AddModal
        show={showModal}
        title={t("addMinorStratum")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-sm font-semibold mb-2">
              {t("chooseSubStratum")}
            </div>
            <SubStrataSelect
              openModal={showModal}
              onSelect={setSubStratumId}
              selected={subStratumId}
            />
          </div>
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateMinorStrata;
